import { COURSE_ADD_VIDEO, COURSE_UPDATE_VIDEO, COURSE_REMOVE_VIDEOS } from '~/graphql/mutations/video'
import { GET_VIDEOS_BY_COURSE_SLUG } from '~/graphql/queries/video'
const actionTypes = {
  COURSE_ADD_VIDEO: 'COURSE_ADD_VIDEO',
  COURSE_UPDATE_VIDEO: 'COURSE_UPDATE_VIDEO',
  COURSE_REMOVE_VIDEOS: 'COURSE_REMOVE_VIDEOS',
  GET_VIDEOS_BY_COURSE_SLUG: 'GET_VIDEOS_BY_COURSE_SLUG',
}

const mutationTypes = {
  SET_ADDING: 'SET_ADDING',
  SET_UPDATING: 'SET_UPDATING',
  SET_REMOVING: 'SET_REMOVING',
  SET_GETTING_VIDEOS: 'SET_GETTING_VIDEOS',
}

export const state = () => ({
  updating: false,
  adding: false,
  removing: false,
  gettingVideo: false,
})

export const mutations = {
  [mutationTypes.SET_UPDATING](state, updating) {
    state.updating = updating
  },
  [mutationTypes.SET_ADDING](state, adding) {
    state.creating = adding
  },
  [mutationTypes.SET_REMOVING](state, removing) {
    state.creating = removing
  },
  [mutationTypes.SET_GETTING_VIDEOS](state, gettingVideo) {
    state.gettingVideo = gettingVideo
  },
}

export const actions = {
  async [actionTypes.COURSE_UPDATE_VIDEO]({ commit }, params) {
    commit(mutationTypes.SET_UPDATING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: COURSE_UPDATE_VIDEO,
        variables: {
          ...params,
        },
      })
      commit(mutationTypes.SET_UPDATING, false)
      return { data, success: true }
    } catch (error) {
      console.error('COURSE_UPDATE_VIDEO', error)
      return { error, success: false }
    }
  },
  async [actionTypes.COURSE_ADD_VIDEO]({ commit }, params) {
    commit(mutationTypes.SET_ADDING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: COURSE_ADD_VIDEO,
        variables: {
          ...params,
        },
      })
      commit(mutationTypes.SET_ADDING, false)
      return { data, success: true }
    } catch (error) {
      console.error('COURSE_ADD_VIDEO', error)
      return { error, success: false }
    }
  },
  async [actionTypes.COURSE_REMOVE_VIDEOS]({ commit }, params) {
    commit(mutationTypes.SET_REMOVING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: COURSE_REMOVE_VIDEOS,
        variables: {
          ...params,
        },
      })
      commit(mutationTypes.SET_REMOVING, false)
      return { data, success: true }
    } catch (error) {
      console.error('COURSE_REMOVE_VIDEOS', error)
      return { error, success: false }
    }
  },
  async [actionTypes.GET_VIDEOS_BY_COURSE_SLUG]({ commit }, slug) {
    commit(mutationTypes.SET_GETTING_VIDEOS, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.query({
        query: GET_VIDEOS_BY_COURSE_SLUG,
        variables: { slug },
      })
      commit(mutationTypes.SET_GETTING_VIDEOS, false)
      return { data, success: true }
    } catch (error) {
      return { error, success: false }
    }
  },
}

export const getters = {
  updating: (state) => state.updating,
  adding: (state) => state.adding,
  removing: (state) => state.removing,
  gettingVideo: (state) => state.gettingVideo,
}
